// extracted by mini-css-extract-plugin
export default {"btnAvaliar":"BtnAvaliar_btnAvaliar__vL8dg","icon":"BtnAvaliar_icon__IxIx4","btnAvaliar__small":"BtnAvaliar_btnAvaliar__small__U3N1L"};